import styled from "@emotion/styled";
import { LightMode, Variables } from "@repo/skapa";

import { zIndex } from "../Variables";

export const PopoverContainer = styled.div<{
  height?: string;
  maxHeight?: string;
}>`
  z-index: ${zIndex.popover};
  background: ${LightMode.colourNeutral1};
  box-shadow: ${Variables.shadowSizeDefault};
  border-radius: ${Variables.radiusM};
  max-height: ${(props) => props.maxHeight ?? props.height};
  overflow-y: auto;
`;
